@if (!isDasboard) {
  <app-table-header
    (reload)="onRefreshList(false)"
    [loading]="loading"
    [withExportOption]="!!data.info.exportTableName"
    (exportBtnClicked)="exportBtnClicked()"
    >
    <app-add-edit-modal (refresh)="onRefreshList(false)"></app-add-edit-modal>
    <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
  </app-table-header>
}


<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzShowPagination]="!isDasboard"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="complaints"
  >
  <thead>
    <tr>
      <th nzColumnKey="id" [nzShowSort]="!isDasboard" [nzSortFn]="true" nzWidth="75px">#ID</th>
      <th nzColumnKey="dateOfReceipt" [nzShowSort]="!isDasboard" [nzSortFn]="true" [nzSortOrder]="isDasboard ? 'descend' : null">Eingangsdatum</th>
      <th nzColumnKey="placeOfReceipt.name" [nzShowSort]="!isDasboard" [nzSortFn]="true">Filiale</th>
      <th nzColumnKey="customerName" [nzShowSort]="!isDasboard" [nzSortFn]="true">Kundenname</th>
      <th nzColumnKey="emailAddress" [nzShowSort]="!isDasboard" [nzSortFn]="true">E-Mail</th>
      <th nzColumnKey="phoneNumber" [nzShowSort]="!isDasboard" [nzSortFn]="true" nzWidth="160px">Telefon</th>
      <th
        nzColumnKey="status"
        [nzShowSort]="!isDasboard"
        [nzSortFn]="true"
        [nzFilters]="isDasboard ? [] : statusFilters"
        [nzFilterFn]="true"
      >Status</th>
      <th nzColumnKey="actions" nzRight nzWidth="100px"></th>
    </tr>
  </thead>
  <tbody>
    @for (complaint of data.results; track complaint) {
      <tr>
        <td>{{ complaint.id }}</td>
        <td>{{ complaint.dateOfReceipt | date:'dd.MM.yyyy' }}</td>
        <td>{{ complaint.placeOfReceipt.name }}</td>
        <td>{{ complaint.customerName }}</td>
        <td>{{ complaint.emailAddress }}</td>
        <td class="cell-nowrap">{{ complaint.phoneNumber }}</td>
        <td>
          <nz-tag [nzColor]="getStatusColor(complaint.status)">
            {{ getStatusLabel(complaint.status) }}
          </nz-tag>
        </td>
        <td nzRight>
          <div class="actions">
            <app-add-edit-modal (refresh)="onRefreshList(false)" #modal>
              <span trigger>
                <app-icon-button
                  icon="edit"
                  [ariaLabel]="'Beschwerde bearbeiten: ' + complaint.id"
                  (pressed)="modal.showModal(complaint)"
                ></app-icon-button>
              </span>
            </app-add-edit-modal>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

@if (!isDasboard) {
  <app-export-table-modal #exportTableModalComponent></app-export-table-modal>
}
